/* OlfaScent: same-page photo viewer and structured WhatsApp enquiries. */
function setupOlfaPhotoViewer(root = document) {
  root.querySelectorAll('[data-product-root]').forEach(product => {
    const gallery = product.querySelector('[data-product-gallery]');
    const dialog = product.querySelector('[data-product-lightbox]');
    if (!gallery || !dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const photo = dialog.querySelector('[data-lightbox-image]');
    const counter = dialog.querySelector('[data-lightbox-count]');
    const previous = dialog.querySelector('[data-lightbox-prev]');
    const next = dialog.querySelector('[data-lightbox-next]');
    let items = [], index = 0, returnFocus = null;
    const show = step => {
      index = (step + items.length) % items.length;
      const item = items[index];
      photo.src = item.href;
      photo.alt = item.querySelector('img')?.alt || 'Foto del producto';
      photo.loading = 'eager';
      counter.textContent = `${index + 1} / ${items.length}`;
      previous.hidden = next.hidden = items.length < 2;
    };
    gallery.addEventListener('click', event => {
      const item = event.target.closest('.product-gallery-tile[href]');
      if (!item || !gallery.contains(item) || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      items = [...gallery.querySelectorAll('.product-gallery-tile[href]')];
      returnFocus = item;
      show(items.indexOf(item));
      dialog.showModal();
      document.body.classList.add('photo-viewer-open');
      dialog.querySelector('[data-lightbox-close]').focus();
    });
    previous.addEventListener('click', () => show(index - 1));
    next.addEventListener('click', () => show(index + 1));
    dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('photo-viewer-open');
      if (returnFocus?.isConnected) returnFocus.focus({preventScroll: true});
    });
  });
}
function setupOlfaWhatsApp(root = document) {
  root.querySelectorAll('[data-contact-panel]').forEach(panel => {
    const form = panel.querySelector('form');
    if (!form || form.dataset.whatsappReady) return;
    form.dataset.whatsappReady = 'true';
    const number = (panel.dataset.whatsappNumber || '').replace(/[^\d]/g, '');
    const label = form.querySelector('[data-contact-submit-label]');
    const note = form.querySelector('[data-contact-note]');
    if (!/^[1-9]\d{7,14}$/.test(number)) {
      if (form.hasAttribute('data-whatsapp-form')) {
        form.addEventListener('submit', event => event.preventDefault());
        form.querySelector('[type=submit]').disabled = true;
        if (label) label.textContent = 'WhatsApp no disponible';
        if (note) note.textContent = 'Nuestro contacto de WhatsApp no está disponible en este momento.';
      } else {
        if (label) label.textContent = 'Solicitar asesoría';
        if (note) note.textContent = 'Envía tu solicitud y nuestro equipo se pondrá en contacto contigo.';
      }
      return;
    }
    if (label) label.textContent = 'Continuar por WhatsApp';
    const value = name => String(form.elements.namedItem(name)?.value || '').trim();
    const option = name => {
      const field = form.elements.namedItem(name);
      return field?.selectedOptions?.[0]?.textContent.trim() || value(name);
    };
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const area = value('contact[Tamaño en m²]');
      const message = [
        '🌿 *OLFASCENT*',
        '*Solicitud de asesoría*',
        '',
        '👤 *DATOS DE CONTACTO*',
        `*Nombre:* ${value('contact[name]')}`,
        `*Celular:* ${value('contact[phone]')}`,
        `*Correo:* ${value('contact[email]')}`,
        '',
        '🏡 *MI ESPACIO*',
        `*Servicio:* ${option('contact[Servicio]')}`,
        `*Espacio:* ${option('contact[Espacio]')}`,
        `*Tamaño aproximado:* ${area ? (/m[²2]/i.test(area) ? area : area + ' m²') : 'Por definir'}`,
        '',
        '💬 *MI SOLICITUD*',
        value('contact[body]')
      ];
      const consent = form.elements.namedItem('contact[Autoriza tratamiento de datos]');
      if (consent?.checked) message.push('', '*Autorización de tratamiento de datos:* Sí');
      const url = `https://wa.me/${number}?text=${encodeURIComponent(message.join('\n'))}`;
      const status = form.querySelector('[data-contact-status]');
      if (status) {
        status.replaceChildren(document.createTextNode('Tu mensaje está listo. '));
        const retry = document.createElement('a');
        retry.href = url;
        retry.textContent = 'Abrir WhatsApp';
        status.append(retry);
        status.hidden = false;
      }
      window.location.assign(url);
    });
  });
}
function setupOlfaEditorial(root = document) { setupOlfaPhotoViewer(root); setupOlfaWhatsApp(root); }
setupOlfaEditorial();
document.addEventListener('shopify:section:load', event => setupOlfaEditorial(event.target));
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('[data-product-lightbox][open]').forEach(dialog => dialog.close());
});
